"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.propertyScoreByPropertyId = void 0;
const helpers_1 = require("../helpers");
exports.propertyScoreByPropertyId = (state = {}, action = {}) => {
    switch (action.type) {
        case 'PROPERTY_SCORE_GET_BY_PROPERTY_RECEIVE':
            const rounding = helpers_1.handleRounding(action.payload.score.score);
            const score = Object.assign(Object.assign({}, action.payload.score), { unrounded_score: rounding.unrounded_score, score: rounding.score });
            return Object.assign(Object.assign({}, state), { [action.payload.id]: score });
        case 'PROPERTY_SCORES_MARK_ATTRIBUTES_AS_VIEWED_BY_PROPERTY_RECEIVE':
            return Object.assign(Object.assign({}, state), { [action.payload.propertyId]: Object.assign(Object.assign({}, state[action.payload.propertyId]), { attributes: action.payload.viewedAttributes }) });
        case 'PROPERTY_SCORES_SNOOZE_ATTRIBUTE_BY_PROPERTY_RECEIVE': {
            const filteredOutSnoozedAttribute = state[action.payload.propertyId].attributes.filter((attr) => attr.attribute_name !== action.payload.snoozedAttribute.attribute_name);
            const attributes = [...filteredOutSnoozedAttribute, action.payload.snoozedAttribute];
            return Object.assign(Object.assign({}, state), { [action.payload.propertyId]: Object.assign(Object.assign({}, state[action.payload.propertyId]), { attributes }) });
        }
        default:
            return state;
    }
};
//# sourceMappingURL=reducer.js.map